// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .scrollable--ajCeK{height:100%;overflow:auto;-ms-scroll-chaining:none;overscroll-behavior:none}", ""]);
// Exports
exports.locals = {
	"scrollable": "scrollable--ajCeK"
};
module.exports = exports;
